<template>
    <div    :class="[togglable ? 'cursor-pointer' : 'cursor-not-allowed']"
            @click.stop="updateChecked">
        <div    v-if="modelValue">
            <svg class="shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
        </div>
        <div    v-else>
            <svg class="shrink-0 mr-1.5 h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clip-rule="evenodd"/>
            </svg>
        </div>
    </div>
</template>

<script>

import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "SmallColoredCheck",
    mixins: [iconNamesMixin],
    components: {},
    emits: ['update:modelValue'],
    compatConfig: { COMPONENT_V_MODEL: false },
    props: {
        modelValue: [Boolean, Number],
        togglable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        updateChecked() {
            if (this.togglable) {
                this.$emit('update:modelValue', !this.modelValue)
            }
        }
    },
    computed: {

    },
    watch: {

    },
}
</script>

<style scoped>

</style>